(function () {
  class FreespinsRetriggerPopup extends PIXI.Container {
    constructor() {
      super();

      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
      Reflex.registerEventHandler(
        "orientationChange",
        this.onOrientationChange.bind(this)
      );

      this.visible = false;
    }

    initialise() {
      this._popupMaskDimObject = resourceManager.get("popupMaskDimObject");

      this._popup = resourceManager.get(
        "featurePopupContainer:freespinsRetriggerPopup"
      );
      this._popup.visible = false;
      this._popupCloseButton = resourceManager.get(
        "featurePopupContainer:freespinsRetriggerPopup:pressStartColourBox"
      );
      this._popupValue = resourceManager.get(
        "featurePopupContainer:freespinsRetriggerPopup:bg:msg2"
      );
    }

    onGameConfigEvent() {
      this.initialise();
    }

    onOrientationChange() {
      if (this._active) {
        this.visible = true;
      }
    }

    show(num, callback) {
      const self = this;
      this.initShowPopup(num, function () {
        callback();
      });
      timerManager.addTimer(
        500,
        function (progress) {
          self.showPopupProgress(progress);
        },
        function () {
          self.showPopupFinished(1);
        }
      );
    }

    initShowPopup(numFS, touchCallback) {
      this._active = true;

      const self = this;
      this._popupCloseButton.touchend = this._popupCloseButton.mouseup =
        function () {
          self._popupCloseButton.interactive = false;
          self._popupCloseButton.touchend = self._popupCloseButton.mouseup =
            function () {};
          self._popupMaskDimObject.show(false);

          self.showPopupFinished(false);

          touchCallback();
        };
      this._popupValue.setTranslationParameters(numFS);
      this.visible = true;
      this.alpha = 0;
    }

    showPopupProgress(progress) {
      this.alpha = progress;
      this._popupMaskDimObject.show(true, progress);
    }

    showPopupFinished(show) {
      this.alpha = 1;
      this.visible = show;
      this._popupMaskDimObject.show(show, 1);
      this._popupCloseButton.interactive = show;
      if (!show) {
        this._active = false;
      }
    }
  }

  var creator = function (json) {
    return new FreespinsRetriggerPopup();
  };

  var initialiser = function (json, buggy) {};

  var filesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "freespinsRetriggerPopup",
    creator,
    initialiser,
    filesRequired
  );
})();
